import { AsessmentInsights } from '../types/api'

export const getRatingPercentage = (focusArea: AsessmentInsights) => {
  const rating = focusArea.midpoint ?? focusArea.initial
  return Math.round((rating * 100.0) / 5)
}
